
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class ApproveCompanyForSaleResponseModel extends Model<ApproveCompanyForSaleResponseModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'vatNumber', type: 'string', languageString: 'approveCompanyForSaleResponse.property.vatNumber' },
		{ name: 'isApprovedForSale', type: 'boolean', languageString: 'approveCompanyForSaleResponse.property.isApprovedForSale' }
	];
	[key: string]: any;
	
	public vatNumber: string;
	public isApprovedForSale: boolean;
    
	constructor(){
		super();
		this.vatNumber = '';
		this.isApprovedForSale = false;
		
	}
	getProperties(){
		return ApproveCompanyForSaleResponseModel.classProperties;
	}
}

